import api from "@modules/api/api";
import { useQuery } from "@tanstack/react-query";
import purchaseQueryKeys from "../purchaseQueryKeys";

type GetDealLinkResponse = {
  type: string;
};

const getDealLink = async (token: string | undefined) => {
  return api.get<GetDealLinkResponse>(`api/purchases/validate-link/${token}`);
};

export default function useGetDealLink(token: string | undefined) {
  const { data, isLoading } = useQuery({
    queryKey: purchaseQueryKeys.getDealLink(token),
    queryFn: () => getDealLink(token),
    enabled: !!token,
  });

  return { data, isLoading };
}
